// src/components/comunicacion/SidebarComunicacion.jsx
import React from "react";

const MENU_ITEMS = [
  { id: "dashboard", label: "Inicio", badge: "" },
  { id: "avisos", label: "Avisos urgentes", badge: "" },
  { id: "noticias", label: "Noticias", badge: "" },
  { id: "articulos", label: "Articulos", badge: "" },
  { id: "calendario", label: "Eventos", badge: "" },
  { id: "encuestas", label: "Encuestas", badge: "" },
  { id: "foros", label: "Foros", badge: "" },
  { id: "gestorDocumentos", label: "Documentos", badge: "" },
  { id: "buzon", label: "Buz�n de ideas", badge: "" },
];

const SidebarComunicacion = ({ activeScreen, onNavigate }) => {
  return (
    <div className="intra-sidebar-shell">
      {/* LOGO / IDENTIDAD */}
      <div className="intra-sidebar-logo-area">
        <div className="intra-sidebar-logo-mark">C</div>
        <div className="intra-sidebar-logo-text">
          <span className="intra-sidebar-logo-title">Comunicaci�n</span>
          <span className="intra-sidebar-logo-subtitle">
            Intranet corporativa
          </span>
        </div>
      </div>

      {/* MEN� PRINCIPAL */}
      <nav className="intra-sidebar-menu">
        {MENU_ITEMS.map((item) => {
          const isActive = activeScreen === item.id;
          return (
            <button
              key={item.id}
              type="button"
              className={`intra-sidebar-menu-item ${isActive ? "is-active" : ""
                }`}
              onClick={() => onNavigate && onNavigate(item.id)}
            >
              <span className="intra-sidebar-menu-icon">
                <span className="intra-sidebar-menu-icon-letter">
                  {item.label.charAt(0)}
                </span>
              </span>
              <span className="intra-sidebar-menu-label">{item.label}</span>
              {item.badge && (
                <span className="intra-sidebar-menu-badge">{item.badge}</span>
              )}
            </button>
          );
        })}
      </nav>

      {/* FOOTER PEQUE�O */}
      <div className="intra-sidebar-footer">
        <span className="intra-sidebar-footer-text">
          M�dulo de comunicaci�n
        </span>
      </div>
    </div>
  );
};

export default SidebarComunicacion;
